import * as Sentry from "@sentry/react";

export const handleError = (e: unknown) => {
  Sentry.captureException(e);
};
